import React, { useCallback } from 'react';

import { isMedia } from '@shared/lib/html';
import { Button } from '@shared/ui/button';
import { GlobalPortal } from '@shared/ui/global-portal';
import { ModalWindow } from '@shared/ui/modal-window';
import IconX from '@assets/img/icons/close-x.svg';

import type { InfoModalProps } from '../model/types';

import styles from './styles.module.scss';

/**
 * Компонент InfoModalProps отображает модальное окно
 */
export const InfoModal = ({
	handleApply,
	setShowModal,
	showModal,
	title,
	modalInfo: { cancelButton, applyButton, modalText },
}: InfoModalProps) => {
	const handleCloseModal = useCallback(() => {
		setShowModal(false);
	}, [setShowModal]);

	if (!showModal) return null;

	const modalContent = (
		<>
			<div className={styles.ModalText}>{modalText}</div>
			<div className={styles.ModalButtons}>
				<Button buttonType={cancelButton.type} onClick={handleCloseModal}>
					{cancelButton.text}
				</Button>
				<Button buttonType={applyButton.type} onClick={handleApply}>
					{applyButton.text}
				</Button>
			</div>
		</>
	);

	if (isMedia('sm')) {
		return (
			<GlobalPortal>
				<div className={styles.Popup}>
					<div className={styles.PopupHeader}>
						<div className={styles.PopupHeaderText}>{title}</div>
						<Button
							buttonType="icon"
							className={styles.PopupClose}
							svg={IconX}
							onClick={handleCloseModal}
						/>
					</div>
					{modalContent}
				</div>
			</GlobalPortal>
		);
	}

	return (
		<ModalWindow
			doClose={setShowModal}
			isShow={showModal}
			modalClassName={styles.ModalWindow}
			title={title}
		>
			{modalContent}
		</ModalWindow>
	);
};
